import { Fragment } from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Delete } from "@mui/icons-material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { UpdateWorkOrderInputSchema } from "DDD/action-objects/WorkOrderItemsUpdate";
import CrewOptions from "modules/crews/CrewOptions";
import CustomSelect from "components/Shared/CustomSelect/CustomSelect";
import AddLabourCost from "modules/proposals/labourCosts/AddLabourCost";
import { JobPhase } from "generated/graphql";
import { denseTableSx, getCrewHours, headerCellSx } from "./utils";

export default function LaborTable({ jobPhase }: { jobPhase: JobPhase }) {
  const { control, register, getValues } = useFormContext<UpdateWorkOrderInputSchema>();
  const {
    fields: crewFields,
    remove: removeCrew,
    append: crewsAppend,
  } = useFieldArray({
    control,
    name: "crews",
  });

  return (
    <MDBox mb={3} sx={{ "@media print": { marginBottom: 1 } }}>
      <TableContainer component={Paper} sx={{ overflowX: "visible" }}>
        <Table aria-label="labor" sx={denseTableSx}>
          <TableBody>
            <TableRow>
              <TableCell variant="head" sx={headerCellSx}>
                Labor
              </TableCell>
              <TableCell variant="head" align="right" width="72px" sx={headerCellSx}>
                Hours
              </TableCell>
              <TableCell
                variant="head"
                align="center"
                width="40px"
                className="no-print"
                sx={headerCellSx}
              >
                <AddLabourCost
                  compactTrigger
                  submitMsg="Add Labor"
                  onAdd={(laborIds) =>
                    laborIds?.forEach((id) => {
                      crewsAppend({
                        id,
                      });
                    })
                  }
                />
              </TableCell>
            </TableRow>
            {crewFields?.map((crew, index) => (
              <Fragment key={crew.id}>
                <TableRow>
                  <TableCell
                    sx={{
                      display: "none",
                      "@media print": {
                        display: "table-cell",
                      },
                    }}
                  >
                    {getValues(`crews.${index}.name`)}
                  </TableCell>
                  <TableCell className="no-print">
                    <CrewOptions>
                      {({ crewOptions }) => (
                        <CustomSelect
                          control={control}
                          name={`crews.${index}.id`}
                          selectVariant="outlined"
                          size="small"
                          data={crewOptions}
                          fullWidth
                          {...register(`crews.${index}.id`)}
                        />
                      )}
                    </CrewOptions>
                  </TableCell>
                  <TableCell align="right">
                    {getCrewHours(jobPhase, getValues(`crews.${index}.id`))}
                  </TableCell>
                  <TableCell align="right" className="no-print">
                    <MDButton
                      variant="text"
                      color="error"
                      type="button"
                      sx={{ minHeight: 0, p: 0 }}
                      onClick={() => removeCrew(index)}
                    >
                      <Delete />
                    </MDButton>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </MDBox>
  );
}
